import React from 'react';
import HotProductsItem from '../HotProductsItem';
import './index.scss';

const HotProductsList = (props) => {
    let {products,toProductDetail} = props;
    return (
        <div className='hotProductsList'>
            {
                products.map((val, index) => {
                    return <HotProductsItem product={val} key={index} index={index - 0 + 1} toProductDetail={toProductDetail}/>
                })
            }
        </div>
    )
}

export default HotProductsList;